import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/cn';
import type { Pregunta } from './preguntas';

/**
 * Una guía desplegable: pregunta, y al abrirla sus pasos y su nota.
 * La usan la página de Ayuda y el botón flotante de ayuda de cada pantalla.
 */
export function Guia({
  pregunta,
  abierta,
  onAlternar,
}: {
  pregunta: Pregunta;
  abierta: boolean;
  onAlternar: () => void;
}) {
  const idPanel = `ayuda-${pregunta.id}`;

  return (
    <li id={pregunta.id} className="scroll-mt-20">
      <h3>
        <button
          type="button"
          aria-expanded={abierta}
          aria-controls={idPanel}
          onClick={onAlternar}
          className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left text-sm font-medium text-fg transition-colors hover:bg-surface-2"
        >
          <span>{pregunta.pregunta}</span>
          <ChevronDown
            className={cn(
              'size-4 shrink-0 text-fg-subtle transition-transform',
              abierta && 'rotate-180',
            )}
            aria-hidden
          />
        </button>
      </h3>

      {abierta && (
        <div id={idPanel} className="space-y-3 px-4 pb-4 text-sm text-fg-muted">
          {pregunta.respuesta && <p className="leading-relaxed">{pregunta.respuesta}</p>}

          {pregunta.pasos && (
            <ol className="space-y-2">
              {pregunta.pasos.map((paso, i) => (
                <li key={i} className="flex gap-3">
                  <span className="tabular flex size-5 shrink-0 items-center justify-center rounded-full bg-brand-soft text-xs font-semibold text-brand-soft-fg">
                    {i + 1}
                  </span>
                  <span className="leading-relaxed">{paso}</span>
                </li>
              ))}
            </ol>
          )}

          {pregunta.nota && (
            <p className="rounded-lg border border-border bg-surface-2 px-3 py-2 text-xs leading-relaxed">
              <strong className="font-semibold text-fg">Ojo: </strong>
              {pregunta.nota}
            </p>
          )}
        </div>
      )}
    </li>
  );
}
